<!-- eslint-disable @angular-eslint/template/elements-content -->
<button
  pButton
  label="Configurar tabla"
  class="p-button-outlined btn-configurar"
  icon="pi pi-cog"
  (click)="onConfigurarTabla($event)"
  [disabled]="isLoading"
></button>

<p-multiSelect
  [options]="internalListColumns"
  [(ngModel)]="selectedListColumns"
  filterPlaceHolder="Search"
  [showToggleAll]="false"
  [autofocusFilter]="false"
  [virtualScroll]="false"
  [filter]="false"
  (onChange)="onChange($event)"
  [placeholder]="'Configurar tabla'"
  (onPanelShow)="onPanelShow()"
  (onPanelHide)="onPanelHide()"
  [class.d-none]="!this.isOpen"
  appendTo="self"
  [panelStyle]="{ width: '320px', top: '10px', left: '-180px' }"
  #multiSelectRef
>
  <ng-template pTemplate="header">
    <div class="custom-header">
      <div class="p-multiselect-header2">
        <p class="title">
          Configura la visualización de la tabla seleccionando las columnas
        </p>
        <button
          class="p-multiselect-close2 p-link"
          type="button"
          (click)="onClose($event)"
          pRipple
        >
          <span class="pi pi-times"></span>
        </button>
      </div>
    </div>
    <div class="boton-todos">
      <p-checkbox
        [binary]="true"
        [(ngModel)]="checkAll"
        (onChange)="onClickAll()"
      ></p-checkbox>
      <span class="texto">Seleccionar todas las columnas</span>
    </div>
  </ng-template>

  <ng-template pTemplate="selectedItems"
    ><i class="fas fa-cog"></i> Configurar tabla
  </ng-template>
  <ng-template let-column pTemplate="item">
    <div class="column-item">
      <div class="texto">{{ column.header }}</div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="custom-footer">
      <button
        class="boton-guardar-configuracion"
        (click)="onSaveConfig($event)"
      >
        <span class="icono"><i class="fas fa-save"></i></span
        ><label class="boton-label">Guardar configuración</label>
      </button>
    </div>
  </ng-template>
</p-multiSelect>
